type CardCrossIconProps = {
  size?: number;
  color?: string;
};

export const CardCrossIcon = ({
  size = 24,
  color = "#3F4756",
}: CardCrossIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.258 19.096H4.452A2.451 2.451 0 0 1 2 16.645V7.452A2.452 2.452 0 0 1 4.452 5H19.16a2.451 2.451 0 0 1 2.452 2.45v4.292m-19-2.452H21m-2.648 9.582 1.824-1.825m0 0L22 15.222m-1.825 1.825-1.824-1.825m1.824 1.825L22 18.872"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
